import React, { useState, useEffect } from 'react';
import { Card, Upload, Button, message, Select, Input, DatePicker, Typography, App } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { BULK_ASSIGN_COURSE } from '../../../apis/apis';
const { Text } = Typography;

function BulEnrollLearners({ course_id, isModalOpen, onSuccess }) {
  const { notification } = App.useApp();

  const [access_type, set_access_type] = useState('LifeTime');
  const [access_value, set_access_value] = useState('');
  const [fileList, setFileList] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState('');

  
  useEffect(() => {
    if (isModalOpen) {
      setFileList([]);
      set_access_value('');
      set_access_type('LifeTime');
      setFileError('');
    }
  }, [isModalOpen]);

 
  const handleBeforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';

    if (!isCSV) {
      message.error('Please upload only CSV file.');
      return Upload.LIST_IGNORE;
    }

    setFileList([file]); 
    setFileError('');
    return false; 
  };

  
  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };

  
  const handleSubmit = async () => {
    if (fileList.length === 0) {
      setFileError('Please select a CSV file before submitting.');
      return;
    }

    if ((access_type === 'FixedDate' || access_type === 'MaxViewingHours') && !access_value) {
      message.error('Please enter access value.');
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append('file', fileList[0].originFileObj); 
      formData.append('course_id', atob(course_id));
      formData.append('access_type', access_type);

      if (access_type !== 'LifeTime') {
        formData.append('access_value', access_value);
      }

      const response = await BULK_ASSIGN_COURSE(formData);

      if (response?.data?.status) {
        notification.success({
          message: 'Successful',
          description: response?.data?.message,
        });

        setFileList([]);
        set_access_value('');

        if (onSuccess) onSuccess();
      } else {
        message.error(response?.data?.message || 'Enrollment failed!');
      }
    } catch (error) {
      message.error('Server error: Could not enroll learners.');
    } finally {
      setLoading(false);
    }
  };

  
  const renderAccessValueInput = () => {
    if (access_type === 'FixedDate') {
      return (
        <>
          <label><b>Access Value (Select Date):</b></label>
          <DatePicker
            style={{ width: 300, marginBottom: '20px' }}
            onChange={(date) =>
              set_access_value(date ? dayjs(date).format('YYYY-MM-DD') : '')
            }
          />
        </>
      );
    }

    if (access_type === 'MaxViewingHours') {
      return (
        <>
          <label><b>Access Value (Enter Hours):</b></label>
          <Input
            style={{ width: 300, marginBottom: '20px' }}
            type="number"
            placeholder="Enter number of hours"
            value={access_value}
            onChange={(e) => set_access_value(e.target.value)}
          />
        </>
      );
    }

    return null;
  };

  return (
    <div className="lms-body">
      <Card>
        <h3>Bulk Enroll Learners to Courses</h3>
        <span>Upload Excel file and submit to enroll learners.</span>

        <div style={{ maxWidth: 600, margin: '15px auto' }}>
          <Card>
            <label><b>Access Type:</b></label>

            <Select
              style={{ width: 300, marginBottom: '20px' }}
              value={access_type}
              onChange={(value) => {
                set_access_type(value);
                set_access_value('');
              }}
              options={[
                { value: 'LifeTime', label: 'LifeTime' },
                { value: 'FixedDate', label: 'Fixed Date' },
                { value: 'MaxViewingHours', label: 'Max Viewing Hours' },
              ]}
            />

            <br />

            {renderAccessValueInput()}
          </Card>
        </div>

       
        <Upload
          beforeUpload={handleBeforeUpload}
          onChange={handleFileChange}
          fileList={fileList}
          onRemove={() => setFileList([])}
          accept=".csv"
        >
          <Button icon={<UploadOutlined />}>Select Excel File</Button>
        </Upload>

        {fileError && (
          <Text type="danger" style={{ display: 'block', marginTop: 8 }}>
            {fileError}
          </Text>
        )}

       
        <div style={{ marginTop: 20 }}>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            Submit
        
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default BulEnrollLearners;
